import axios from "axios";
import { CalendarPerimeter } from "./types";
import { callWsCached } from "./utils";

function gtfsGetCalendarPerimeter(
  gtfsUri: string,
  encodeUriPath: Boolean,
  network: string
): Promise<CalendarPerimeter> {
  let url = `/calendar-perimeter?reseau=${network}`;
  if (encodeUriPath) {
    url = encodeURIComponent(url);
  }
  url = `${gtfsUri}${url}`;
  return axios({ method: "get", url }).then(resp => {
    let gtfsRawLine = resp.data;
    let calendarPerimeter: CalendarPerimeter = {
      start: gtfsRawLine.start,
      end: gtfsRawLine.end,
    };
    return calendarPerimeter;
  });
}

export default async function(
  gtfsUri: string,
  encodeUriPath: Boolean,
  network: string,
): Promise<CalendarPerimeter> {
  let prefix = `${gtfsUri}-${network}`;
  let key = `${prefix}-calendar-perimeter`;
  // Calendar perimeter is time base cached
  let proxyGetValue: Function = callWsCached(
    key,
    () => gtfsGetCalendarPerimeter(gtfsUri, encodeUriPath, network),
  );

  let proxiedValue = await proxyGetValue();
  return JSON.parse(JSON.stringify(proxiedValue));
}
